import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ProgressBar from "react-bootstrap/ProgressBar";
import "./PersonReviewedIndicator.css";

function PersonReviewedIndicator({ id, description, grade, weight }) {
  const { t } = useTranslation();

  return (
    <Col key={id} className="person-reviewed-indicator">
      <Row className="justify-content-center align-items-center">
        <Col lg={8}>
          <p className="person-reviewed-indicator-description">{description}</p>
        </Col>
        <Col lg={3} className="right">
          {isNaN(grade) || grade === null ? (
            "N/A"
          ) : (
            <ProgressBar
              now={grade.toFixed(2)}
              label={`${grade.toFixed(2)}%`}
            />
          )}
        </Col>
        <Col lg={1} className="right">
          <h6 className="person-reviewed-indicator-weight">{weight}</h6>
        </Col>
      </Row>
    </Col>
  );
}

export default PersonReviewedIndicator;
